import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,          // data stays fresh for 30s
      refetchOnWindowFocus: true, // refetch when app regains focus (Telegram tab switch)
      refetchInterval: 30_000,    // poll every 30s as background refresh
      retry: 1,
    },
  },
});
